var map = {
	"./flag_de.png": 275,
	"./flag_en.png": 4871,
	"./flag_es.png": 6674,
	"./flag_fr.png": 4230,
	"./flag_it.png": 1793,
	"./flag_pt.png": 2870
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3015;